import { render, staticRenderFns } from "./EditPendingDialog.vue?vue&type=template&id=de129cc2&"
import script from "./EditPendingDialog.vue?vue&type=script&lang=js&"
export * from "./EditPendingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports